export default {
  ['title']: '大赛流程',
  ['sub-title']: 'COMPETITION PROCEDURE',
  ['label-detail']: '查看详情',
  ['label-sign']: '报名参赛',
  ['label-submit']: '提交作品',
  ['label-guide']: '大赛指南',
  ['label-judge']: '专家评审登录',
}
